export const FIREBASE_KEY_PREFIX = 'FIREBASE_';

export const FIREBASE_PROVIDER_EMAIL = 'email';
export const FIREBASE_PROVIDER_ANON = 'anonymous';
export const FIREBASE_PROVIDER_GOOGLE = 'google.com';
export const FIREBASE_PROVIDER_GITHUB = 'github.com';
export const FIREBASE_PROVIDER_TWITTER = 'twitter.com';
export const FIREBASE_PROVIDER_FACEBOOK = 'facebook.com';

export const FIREBASE_PERSISTENCE_NONE = 'none';
export const FIREBASE_PERSISTENCE_LOCAL = 'local';
export const FIREBASE_PERSISTENCE_SESSION = 'session';
